<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Facturen</h3>
            </app-intro>

            <transition-group class="g-cols:2>sm g-cols:3>md g-cols:2>lg g-cols:3>xl || g-gap:1-xs g-gap:1-sm>sm" name="fade" tag="section" v-if="locations.length > 0">

                <router-link :to="`/admin/invoices/${location.VestigingID}`" class="c-node" v-for="location in locations" :key="'location-' + location.VestigingID">
                    <h4 class="c-node__title">{{ location.Vestigingsnaam }}</h4>
                    <ul class="c-node__list">
                        <li>{{ location.Vestigingsadres }}</li>
                        <li>{{ location.Contactpersoon }}</li>
                    </ul>
                </router-link>

            </transition-group>

            <div v-else>
                <p>Er zijn nog geen vestigingen aangemaakt. Maak er <router-link to="/admin/locations/add">hier</router-link> een aan.</p>
            </div>

            <loading v-bind:nodes="locations">Bezig met laden van de vestigingen...</loading>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Loading from '../../components/Loading.vue';

    export default {
        components: { AppIntro, Loading },
        data () {
            return {

            };
        },
        computed: {
            ...mapState({
                locations: (state) => state.location.list,
            }),
        },
        created () {
            this.$store.dispatch('location/list');
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    /*.table {
        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
            margin: 0;
            max-width: 100%;
        }
    }*/
</style>
